<template>
  <div class="content">
    <div v-if="!isAuthenticated">
      <h2 class="title">Welcome</h2>
      <p class="is-size-5">
        This workbench allows you to log in using your Microsoft account.
      </p>
      <p class="mb-6">
        <button
          type="button"
          id="btn-auth-login"
          class="button is-medium is-link"
          @click="login"
        >
          <span class="icon"><i class="fas fa-key"></i></span>
          <span>Log in with Microsoft</span>
        </button>
      </p>
      <hr />
      <p>
        <b>Don’t have an account on this workbench yet?</b><br />
        Contact the
        <a href="https://rsc.service-now.com/technology">Technology Service Desk</a>
        for assistance.
      </p>
    </div>

    <div v-if="isAuthenticated">
      <h2 class="title">Welcome{{ userName ? ` back, ${userName}!` : '' }}</h2>
    </div>
  </div>
</template>

<script>
import { msalInstance } from '@/auth/msalInstance';

export default {
  name: 'Home',
  data() {
    return {
      account: null,
    };
  },
  computed: {
    isAuthenticated() {
      return !!this.account;
    },
    userName() {
      return this.account?.name || '';
    },
  },
  mounted() {
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (account) {
      msalInstance.setActiveAccount(account);
      this.account = account;
    }
  },
  methods: {
    async login() {
      await msalInstance.loginRedirect({
        scopes: ['openid', 'profile', 'email'],
      });
    },
  },
};
</script>